import { Messages } from '../../codegen/Localize';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { GetLocalesRequest } from '../ServerApi/requests/GetLocalesRequest';
import { ILocale } from '../ServerApi/types/ILocale';

export class Locales {

  public getAll(): Promise<ILocale[]> {
    return WebHttpClient.sendRequest(new GetLocalesRequest()).then(result => result.locales);
  }

  // a special value for the user locale that indicates that we should use the server locale
  public unspecifiedLocale(): ILocale {
    return {
      displayName: Messages.unspecified(),
      locale: null
    };
  }

}

export const LocalesInstance = new Locales();
